import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {PrescriptionSummaryModel} from './prescriptionSummary.model';
import {ConsultationSummaryModel} from '../../../../consultation/consultation/api/model/consultationSummary.model';
import {PrescriptionLineModel} from './prescriptionLine.model';

export class PrescriptionModel extends WithSummaryModel<PrescriptionSummaryModel>{
    comment: string;
    lines: PrescriptionLineModel [] = [];
    consultation: ConsultationSummaryModel;
    text: string;
}
